<template>
  <input 
      type="checkbox" 
      :checked="params.value"
      :disabled="true"
    />
</template>

<script>
export default {
  name: "boolean-cell"
};
</script>